const Services = [
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Creative Design',
      content: 'The creative design includes designs that are unique, effective and memorable.',
    },
    {
      icon: 'ri-palette-line',
      title: 'Unlimited Colors',
      content: 'The collection of rules and guidelines which designers use to communicate with users through appealing.',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Strategy Solutions',
      content: 'Business development firm that provides strategic planning, market research services and project.',
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Awesome Support',
      content: 'Awesome Support is the most versatile and feature-rich support plugin for all version.',
    },
    {
      icon: 'ri-stack-line',
      title: 'Truly Multipurpose',
      content: 'You usually get a broad range of options to play with. This enables you to use a single theme across multiple.',
    },
    {
      icon: 'ri-settings-2-line',
      title: 'Easy to customize',
      content: 'Personalise your own website, no matter what theme and what customization options.',
    },
    {
      icon: 'ri-slideshow-line',
      title: 'Responsive & Clean Design',
      content: 'Responsive design is a graphic user interface (GUI) design approach used to create content.',
    },
    {
      icon: 'ri-google-fill',
      title: 'Google Font Collection',
      content: 'Google Fonts is a collection of 915 fonts, all available to use for free on your website.',
    },
    {
      icon: 'ri-briefcase-5-line',
      title: 'Top Industry Specialists',
      content: 'An industrial specialist works with industrial operations to ensure that manufacturing facilities work',
    },
  ];
  
  
  export { Services };
  